import { render, staticRenderFns } from "./DashboardHrd.vue?vue&type=template&id=3a0a041c&"
import script from "./DashboardHrd.vue?vue&type=script&lang=js&"
export * from "./DashboardHrd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports